import React, { useEffect, useRef, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Grid,
  TextField,
  Typography,
  Autocomplete,
} from "@mui/material";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import ProjectViewController from "../../redux/actions/ProjectApiAction";
import TaskVeiwController from "../../redux/actions/TaskApiAction";
import EmployeeProfileVeiwController from "../../redux/actions/EmployeeProfileApiAction";
import EmployerViewController from "../../redux/actions/EmployerApiAction";
import { FadeLoader } from "react-spinners";
import { IMAGE_URL } from "../../services/api";
import { getUserInfoFromToken } from "../../utils/authUtils";
import ProtectedImage from "../../components/ProtectedImage";

const AddTaskFormModal = ({ show, handleClose, initialData = null, selectedProject, onSave }) => {
  // const userType = localStorage.getItem("user_type");
  const [userType, setUserType] = useState(null);
  const [userId, setUserId] = useState(null);
  // const userId = localStorage.getItem("user_id");

  const dispatch = useDispatch();
  const { addTask, updateTask } = TaskVeiwController();
  const { getProjects } = ProjectViewController();
  const { getAllEmployeeEmployer } = EmployerViewController();
  const { employers } = useSelector((state) => state.employer);
  const { projects } = useSelector((state) => state.project);
  const { isLoding } = useSelector((state) => state.task);

  const isEdit = Boolean(initialData?.id);

  const CATEGORY_OPTIONS = [
    { value: "Task", label: "Task" },
    { value: "Issue", label: "Issue Tracker" },
  ];

  const PRIORITY_OPTIONS = [
    { value: "Low", label: "Low" },
    { value: "Medium", label: "Medium" },
    { value: "High", label: "High" },
    { value: "Critical", label: "Critical" },
  ];

  const STATUS_OPTIONS = [
    { value: "New", label: "New" },
    { value: "Pending", label: "Pending" },
    { value: "In Progress", label: "In Progress" },
    { value: "Completed", label: "Completed" },
  ];

  const initialValues = {
    project: initialData?.project?.id || selectedProject?.id || "",
    title: initialData?.title || "",
    description: initialData?.description || "",
    assigned_to: initialData?.assigned_to?.id || "",
    status: initialData?.status || "",
    priority: initialData?.priority || "",
    category: initialData?.category || "",
    start_date: initialData?.start_date || "",
    end_date: initialData?.end_date || "",
    issue_logged_by_employer: initialData?.issue_logged_by_employer || "",
    issue_logged_by_employee: initialData?.issue_logged_by_employee || "",
    attachments: [],
  };

  const projectTitle =
    initialData?.project?.title ||
    selectedProject?.title ||
    "No project selected";

  const existingAttachments = initialData?.attachments || [];

  useEffect(() => {
    if (show) {
      if (!employers?.length) dispatch(getAllEmployeeEmployer());
      if (!projects?.length) dispatch(getProjects());
    }
  }, [show]);
  const formikRef = useRef();
                          useEffect(() => {
                          const { userType, userId } = getUserInfoFromToken();
                          setUserType(userType);
                          setUserId(userId);
                        }, []);

  const validationSchema = Yup.object().shape({
    category: Yup.string().required("Category is required"),
    title: Yup.string().required("Title is required"),
    description: Yup.string().required("Description is required"),
    assigned_to: Yup.string().required("Assigned To is required"),
    priority: Yup.string().required("Priority is required"),
    status: Yup.string().required("Status is required"),
    start_date: Yup.string().required("Start Date is required"),
    end_date: Yup.string().required("End Date is required"),
  });

  const handleSubmit = (values, { resetForm }) => {
    const formData = new FormData();
    values.issue_logged_by_employer = userType === "employer" ? userId : "";
    values.issue_logged_by_employee = userType === "employee" ? userId : "";

    Object.entries(values).forEach(([key, value]) => {
      if (key === "attachments") {
        for (let file of value) formData.append("attachments", file);
      } else {
        formData.append(key, value);
      }
    });

    const action = isEdit
      ? updateTask(initialData.id, formData)
      : addTask(formData);

    dispatch(action)
      .then(() => {
        resetForm();
        if (onSave) onSave(values.project, values.category);
        handleClose();
      })
      .catch((err) => console.error("Submit error:", err));
  };

  return (
  <Dialog open={show} onClose={handleClose} maxWidth="md" fullWidth scroll="paper">
    <DialogTitle
      sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}
    >
      {isEdit ? (initialData?.category === "Issue" ? "Edit Issue" : "Edit Task") : "Add Task"}
    </DialogTitle>

    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={handleSubmit}
      enableReinitialize
    >
      {({ values, errors, touched, setFieldValue, handleChange }) => (
        <Form>
          <DialogContent dividers sx={{ maxHeight: "65vh", overflowY: "auto" }}>
            <Grid container spacing={2}>
              <Grid item xs={12} md={6}>
                <Autocomplete
                  fullWidth
                  options={CATEGORY_OPTIONS}
                  getOptionLabel={(option) => option.label}
                  value={CATEGORY_OPTIONS.find(opt => opt.value === values.category) || null}
                  onChange={(e, newValue) => setFieldValue("category", newValue?.value || "")}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Category"
                      size="small"
                      error={touched.category && Boolean(errors.category)}
                      helperText={touched.category && errors.category}
                      InputProps={{ ...params.InputProps, sx: { height: 48 } }}
                    />
                  )}
                />
              </Grid>

              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  label="Project"
                  size="small"
                  value={projectTitle}
                  disabled
                  InputProps={{ sx: { height: 48 } }}
                />
              </Grid>

              <Grid item xs={12} md={6}>
                <TextField
                  name="title"
                  label="Title"
                  value={values.title}
                  onChange={handleChange}
                  fullWidth
                  size="small"
                  error={touched.title && Boolean(errors.title)}
                  helperText={touched.title && errors.title}
                  InputProps={{ sx: { height: 48 } }}
                />
              </Grid>

              <Grid item xs={12} md={6}>
                <Autocomplete
                  fullWidth
                  options={employers}
                  getOptionLabel={(emp) => `${emp.first_name} ${emp.last_name}`}
                  value={employers.find((e) => e.id === values.assigned_to) || null}
                  onChange={(event, newValue) =>
                    setFieldValue("assigned_to", newValue ? newValue.id : "")
                  }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Assigned To"
                      size="small"
                      error={touched.assigned_to && Boolean(errors.assigned_to)}
                      helperText={touched.assigned_to && errors.assigned_to}
                      InputProps={{ ...params.InputProps, sx: { height: 48 } }}
                    />
                  )}
                />
              </Grid>

              <Grid item xs={12}>
                <TextField
                  name="description"
                  label="Description"
                  value={values.description}
                  onChange={handleChange}
                  multiline
                  rows={3}
                  fullWidth
                  size="small"
                  error={touched.description && Boolean(errors.description)}
                  helperText={touched.description && errors.description}
                />
              </Grid>

              <Grid item xs={12} md={6}>
                <Autocomplete
                  fullWidth
                  options={PRIORITY_OPTIONS}
                  getOptionLabel={(opt) => opt.label}
                  value={PRIORITY_OPTIONS.find((opt) => opt.value === values.priority) || null}
                  onChange={(e, newValue) => setFieldValue("priority", newValue?.value || "")}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Priority"
                      size="small"
                      error={touched.priority && Boolean(errors.priority)}
                      helperText={touched.priority && errors.priority}
                      InputProps={{ ...params.InputProps, sx: { height: 48 } }}
                    />
                  )}
                />
              </Grid>

              <Grid item xs={12} md={6}>
                <Autocomplete
                  fullWidth
                  options={STATUS_OPTIONS}
                  getOptionLabel={(opt) => opt.label}
                  value={STATUS_OPTIONS.find((opt) => opt.value === values.status) || null}
                  onChange={(e, newValue) => setFieldValue("status", newValue?.value || "")}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Status"
                      size="small"
                      error={touched.status && Boolean(errors.status)}
                      helperText={touched.status && errors.status}
                      InputProps={{ ...params.InputProps, sx: { height: 48 } }}
                    />
                  )}
                />
              </Grid>

              <Grid item xs={12} md={6}>
                <TextField
                  type="date"
                  name="start_date"
                  label="Start Date"
                  value={values.start_date}
                  onChange={handleChange}
                  fullWidth
                  size="small"
                  InputLabelProps={{ shrink: true }}
                  error={touched.start_date && Boolean(errors.start_date)}
                  helperText={touched.start_date && errors.start_date}
                  InputProps={{ sx: { height: 48 } }}
                />
              </Grid>

              <Grid item xs={12} md={6}>
                <TextField
                  type="date"
                  name="end_date"
                  label="End Date"
                  value={values.end_date}
                  onChange={handleChange}
                  fullWidth
                  size="small"
                  InputLabelProps={{ shrink: true }}
                  error={touched.end_date && Boolean(errors.end_date)}
                  helperText={touched.end_date && errors.end_date}
                  InputProps={{ sx: { height: 48 } }}
                />
              </Grid>

              <Grid item xs={12}>
                <Typography gutterBottom>Attachments</Typography>
                <Button
                  variant="outlined"
                  component="label"
                  fullWidth
                  size="small"
                >
                  Upload Files
                  <input
                    name="attachments"
                    type="file"
                    multiple
                    hidden
                    onChange={(event) => {
                      setFieldValue("attachments", event.currentTarget.files);
                    }}
                  />
                </Button>

                {values.attachments?.length > 0 && (
                  <ul style={{ marginTop: 8, paddingLeft: 20 }}>
                    {Array.from(values.attachments).map((file, index) => (
                      <li key={index} style={{ fontSize: "0.875rem" }}>
                        {file.name}
                      </li>
                    ))}
                  </ul>
                )}
              </Grid>

              {isEdit && existingAttachments.length > 0 && (
                <Grid item xs={12}>
                  <Typography gutterBottom>Existing Attachments:</Typography>
                  <div style={{ display: "flex", flexWrap: "wrap", gap: 8 }}>
                    {existingAttachments.map((url, index) => {
                      const fullUrl = `${IMAGE_URL}${url}`;
                      const isPDF = fullUrl.toLowerCase().endsWith(".pdf");
                      const isImage = /\.(jpg|jpeg|png|gif)$/i.test(fullUrl);

                      return isImage ? (
                        // <img
                        //   key={index}
                        //   src={fullUrl}
                        //   alt={`Attachment ${index + 1}`}
                        //   style={{
                        //     width: "100px",
                        //     height: "100px",
                        //     objectFit: "cover",
                        //     borderRadius: "8px",
                        //     cursor: "pointer",
                        //     border: "1px solid #ccc",
                        //   }}
                        //   onClick={() => window.open(fullUrl, "_blank")}
                        // />
                        <ProtectedImage
  key={index}
  path={fullUrl}
  alt={`Attachment ${index + 1}`}
  style={{
    width: "100px",
    height: "100px",
    objectFit: "cover",
    borderRadius: "8px",
    cursor: "pointer",
    border: "1px solid #ccc",
  }}
  onClick={() => window.open(fullUrl, "_blank")}
/>

                      ) : (
                        <Button
                          key={index}
                          onClick={() => window.open(fullUrl, "_blank")}
                          size="small"
                        >
                          {isPDF ? `View PDF ${index + 1}` : `Download File ${index + 1}`}
                        </Button>
                      );
                    })}
                  </div>
                </Grid>
              )}
            </Grid>
          </DialogContent>

          {/* Sticky Footer with Buttons */}
          <DialogActions
            sx={{
              position: "sticky",
              bottom: 0,
              bgcolor: "background.paper",
              borderTop: "1px solid #e0e0e0",
              zIndex: 1,
            }}
          >
            <Button variant="outlined" onClick={handleClose}>
              Cancel
            </Button>
            <Button type="submit" variant="contained">
              {isEdit ? "Update Task" : "Create Task"}
            </Button>

             {isLoding && (
                <div
                  style={{
                    position: "fixed",
                    top: 0,
                    left: 0,
                    height: "100vh",
                    width: "100vw",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    background: "rgba(255, 255, 255, 0.6)",
                    zIndex: 9999,
                  }}
                >
                  <div
                    style={{
                      background:
                        "linear-gradient(45deg,rgb(65, 63, 63),rgb(238, 231, 238))",
                      WebkitBackgroundClip: "text",
                      WebkitTextFillColor: "transparent",
                    }}
                  >
                    <FadeLoader loading={true} size={150} aria-label="Loading Spinner" />
                  </div>
                </div>
              )}
          </DialogActions>
        </Form>
      )}
    </Formik>
  </Dialog>
);

};

export default AddTaskFormModal;






















// import React, { useEffect, useState } from "react";
// import { Modal, Col, Row } from "react-bootstrap";
// import {
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   Button,
//   Grid,
//   MenuItem,
//   TextField,
//   Typography,
// } from "@mui/material";
// import { Formik, Form, Field, ErrorMessage } from "formik";
// import * as Yup from "yup";
// import { useDispatch, useSelector } from "react-redux";
// import MasterViewController from "../../redux/actions/masterApiActions";
// import ProjectViewController from "../../redux/actions/ProjectApiAction";
// import TaskVeiwController from "../../redux/actions/TaskApiAction";
// import EmployeeProfileVeiwController from "../../redux/actions/EmployeeProfileApiAction";

// const AddTaskFormModal = ({ show, handleClose, initialData = null, selectedProject, onSave }) => {
//   const userType = localStorage.getItem("user_type");
//   const userId = localStorage.getItem("user_id");

//   const dispatch = useDispatch();
//   const { getEmployees } = EmployeeProfileVeiwController();
//   const { addTask, updateTask } = TaskVeiwController();
//   const { getProjects } = ProjectViewController();
//   const { employee_data } = useSelector((state) => state.employeeProfile);
//   const employees = employee_data?.employees || [];
//   const { projects } = useSelector((state) => state.project);
//   const isEdit = Boolean(initialData?.id);

//   const CATEGORY_OPTIONS = [
//     { value: "Task", label: "Task" },
//     { value: "Issue", label: "Issue Tracker" },
//   ];

//   const PRIORITY_OPTIONS = [
//     { value: "Low", label: "Low" },
//     { value: "Medium", label: "Medium" },
//     { value: "High", label: "High" },
//     { value: "Critical", label: "Critical" },
//   ];

//   const STATUS_OPTIONS = [
//     { value: "New", label: "New" },
//     { value: "Pending", label: "Pending" },
//     { value: "In Progress", label: "In Progress" },
//     { value: "Completed", label: "Completed" },
//   ];

//   const [initialValues, setInitialValues] = useState({
//     project: selectedProject?.id || "",
//     title: "",
//     description: "",
//     assigned_to: "",
//     status: "",
//     priority: "",
//     category: "",
//     start_date: "",
//     end_date: "",
//     issue_logged_by_employer: "",
//     issue_logged_by_employee: "",
//     attachments: [],
//   });

//   const [projectTitle, setProjectTitle] = useState(selectedProject?.title || "No project selected");
//   const existingAttachments = initialData?.attachments || [];

//   useEffect(() => {
//     if (show) {
//       if (!employees || employees.length === 0) {
//         dispatch(getEmployees());
//       }
//       if (!projects || projects.length === 0) {
//         dispatch(getProjects());
//       }
//     }

//     if (show && initialData) {
//       setInitialValues({
//         project: initialData.project?.id || selectedProject?.id || "",
//         title: initialData.title || "",
//         description: initialData.description || "",
//         assigned_to: initialData.assigned_to.id || "",
//         status: initialData.status || "",
//         priority: initialData.priority || "",
//         category: initialData.category || "",
//         start_date: initialData.start_date || "",
//         end_date: initialData.end_date || "",
//         issue_logged_by_employer: initialData.issue_logged_by_employer || "",
//         issue_logged_by_employee: initialData.issue_logged_by_employee || "",
//         attachments: [],
//       });
//       setProjectTitle(initialData.project?.title || selectedProject?.title || "No project selected");
//     } else if (show && selectedProject) {
//       setInitialValues(prev => ({ ...prev, project: selectedProject.id }));
//       setProjectTitle(selectedProject.title);
//     }
//   }, [show, initialData, selectedProject]);

//   const validationSchema = Yup.object().shape({
//     category: Yup.string().required("Category is required"),
//     title: Yup.string().required("Title is required"),
//     description: Yup.string().required("Description is required"),
//     assigned_to: Yup.string().required("Assigned To is required"),
//     priority: Yup.string().required("Priority is required"),
//     status: Yup.string().required("Status is required"),
//     start_date: Yup.string().required("Start Date is required"),
//     end_date: Yup.string().required("End Date is required"),
//   });

//   const handleSubmit = (values, { resetForm }) => {
//     const formData = new FormData();

//     if (userType === "employer") {
//       values.issue_logged_by_employer = userId;
//       values.issue_logged_by_employee = "";
//     } else if (userType === "employee") {
//       values.issue_logged_by_employee = userId;
//       values.issue_logged_by_employer = "";
//     }

//     for (let key in values) {
//       if (key === "attachments") {
//         for (let i = 0; i < values.attachments.length; i++) {
//           formData.append("attachments", values.attachments[i]);
//         }
//       } else {
//         formData.append(key, values[key]);
//       }
//     }

//     const action = isEdit
//       ? updateTask(initialData.id, formData)
//       : addTask(formData);

//     dispatch(action)
//       .then(() => {
//         resetForm();
//         if (onSave) {
//           onSave(values.project, values.category);
//         }
//         handleClose();
//       })
//       .catch((error) => {
//         console.error("Error submitting task:", error);
//       });
//   };

//   return (
//    <Dialog open={show} onClose={handleClose} fullWidth maxWidth="md">
//   <DialogTitle>{isEdit ? (initialData?.category === "Issue" ? "Edit Issue" : "Edit Task") : "Add Task"}</DialogTitle>

//   <Formik
//     initialValues={initialValues}
//     validationSchema={validationSchema}
//     onSubmit={handleSubmit}
//     enableReinitialize
//   >
//     {({ values, errors, touched, setFieldValue, handleChange }) => (
//       <Form>
//         <DialogContent  dividers
//           style={{
//             maxHeight: '65vh',
//             overflowY: 'auto',
//           }}>

//           {/* Category & Project Title */}
//           <Grid container spacing={2}>
//             <Grid item xs={6}>
//               <Typography gutterBottom>Category <span style={{ color: 'red' }}>*</span></Typography>
//               <TextField
//                 select
//                 name="category"
//                 value={values.category}
//                 onChange={handleChange}
//                 fullWidth
//                 size="small"
//                 error={touched.category && Boolean(errors.category)}
//                 helperText={touched.category && errors.category}
//               >
//                 {CATEGORY_OPTIONS.map(opt => (
//                   <MenuItem key={opt.value} value={opt.value}>{opt.label}</MenuItem>
//                 ))}
//               </TextField>
//             </Grid>
//             <Grid item xs={6}>
//               <Typography gutterBottom>Project</Typography>
//               <TextField fullWidth size="small" value={projectTitle} disabled />
//             </Grid>
//           </Grid>

//           {/* Title */}
//           <Typography gutterBottom className="mt-3">Title <span style={{ color: 'red' }}>*</span></Typography>
//           <TextField
//             name="title"
//             value={values.title}
//             onChange={handleChange}
//             fullWidth
//             size="small"
//             error={touched.title && Boolean(errors.title)}
//             helperText={touched.title && errors.title}
//           />

//           {/* Description */}
//           <Typography gutterBottom className="mt-3">Description <span style={{ color: 'red' }}>*</span></Typography>
//           <TextField
//             name="description"
//             value={values.description}
//             onChange={handleChange}
//             multiline
//             rows={3}
//             fullWidth
//             size="small"
//             error={touched.description && Boolean(errors.description)}
//             helperText={touched.description && errors.description}
//           />

//           {/* Assigned To */}
//           <Typography gutterBottom className="mt-3">Assigned To <span style={{ color: 'red' }}>*</span></Typography>
//           <TextField
//             select
//             name="assigned_to"
//             value={values.assigned_to}
//             onChange={handleChange}
//             fullWidth
//             size="small"
//             error={touched.assigned_to && Boolean(errors.assigned_to)}
//             helperText={touched.assigned_to && errors.assigned_to}
//           >
//             {employees.map(emp => (
//               <MenuItem key={emp.id} value={emp.id}>
//                 {emp.first_name} {emp.last_name}
//               </MenuItem>
//             ))}
//           </TextField>

//           {/* Priority & Status */}
//           <Grid container spacing={2} className="mt-2">
//             <Grid item xs={6}>
//               <Typography gutterBottom>Priority <span style={{ color: 'red' }}>*</span></Typography>
//               <TextField
//                 select
//                 name="priority"
//                 value={values.priority}
//                 onChange={handleChange}
//                 fullWidth
//                 size="small"
//                 error={touched.priority && Boolean(errors.priority)}
//                 helperText={touched.priority && errors.priority}
//               >
//                 {PRIORITY_OPTIONS.map(opt => (
//                   <MenuItem key={opt.value} value={opt.value}>{opt.label}</MenuItem>
//                 ))}
//               </TextField>
//             </Grid>
//             <Grid item xs={6}>
//               <Typography gutterBottom>Status <span style={{ color: 'red' }}>*</span></Typography>
//               <TextField
//                 select
//                 name="status"
//                 value={values.status}
//                 onChange={handleChange}
//                 fullWidth
//                 size="small"
//                 error={touched.status && Boolean(errors.status)}
//                 helperText={touched.status && errors.status}
//               >
//                 {STATUS_OPTIONS.map(opt => (
//                   <MenuItem key={opt.value} value={opt.value}>{opt.label}</MenuItem>
//                 ))}
//               </TextField>
//             </Grid>
//           </Grid>

//           {/* Start and End Dates */}
//           <Grid container spacing={2} className="mt-2">
//             <Grid item xs={6}>
//               <Typography gutterBottom>Start Date <span style={{ color: 'red' }}>*</span></Typography>
//               <TextField
//                 type="date"
//                 name="start_date"
//                 value={values.start_date}
//                 onChange={handleChange}
//                 fullWidth
//                 size="small"
//                 error={touched.start_date && Boolean(errors.start_date)}
//                 helperText={touched.start_date && errors.start_date}
//               />
//             </Grid>
//             <Grid item xs={6}>
//               <Typography gutterBottom>End Date <span style={{ color: 'red' }}>*</span></Typography>
//               <TextField
//                 type="date"
//                 name="end_date"
//                 value={values.end_date}
//                 onChange={handleChange}
//                 fullWidth
//                 size="small"
//                 error={touched.end_date && Boolean(errors.end_date)}
//                 helperText={touched.end_date && errors.end_date}
//               />
//             </Grid>
//           </Grid>

//           {/* Attachments */}
//           <Typography gutterBottom className="mt-3">Attachments</Typography>
//           <Button
//             variant="outlined"
//             component="label"
//             fullWidth
//             size="small"
//           >
//             Upload Files
//             <input
//               name="attachments"
//               type="file"
//               multiple
//               hidden
//               onChange={(event) => {
//                 setFieldValue("attachments", event.currentTarget.files);
//               }}
//             />
//           </Button>

//           {/* Selected file names preview */}
//           {values.attachments && values.attachments.length > 0 && (
//             <ul style={{ marginTop: 8, paddingLeft: 20 }}>
//               {Array.from(values.attachments).map((file, index) => (
//                 <li key={index} style={{ fontSize: "0.875rem" }}>{file.name}</li>
//               ))}
//             </ul>
//           )}

//           {/* Existing Attachments Preview */}
//           {isEdit && existingAttachments.length > 0 && (
//             <>
//               <Typography gutterBottom className="mt-3">Existing Attachments:</Typography>
//               <div style={{ display: "flex", flexWrap: "wrap", gap: 8 }}>
//                 {existingAttachments.map((url, index) => {
//                   const fullUrl = `http://localhost:8000${url}`;
//                   const isPDF = fullUrl.toLowerCase().endsWith(".pdf");
//                   const isImage = /\.(jpg|jpeg|png|gif)$/i.test(fullUrl);

//                   if (isImage) {
//                     return (
//                       <img
//                         key={index}
//                         src={fullUrl}
//                         alt={`Attachment ${index + 1}`}
//                         style={{
//                           width: "100px",
//                           height: "100px",
//                           objectFit: "cover",
//                           borderRadius: "8px",
//                           cursor: "pointer",
//                           border: "1px solid #ccc",
//                         }}
//                         onClick={() => window.open(fullUrl, "_blank")}
//                       />
//                     );
//                   }

//                   return (
//                     <Button
//                       key={index}
//                       onClick={() => window.open(fullUrl, "_blank")}
//                       size="small"
//                     >
//                       {isPDF ? `View PDF ${index + 1}` : `Download File ${index + 1}`}
//                     </Button>
//                   );
//                 })}
//               </div>
//             </>
//           )}
//         </DialogContent>

//         <DialogActions>
//           <Button variant="outlined" onClick={handleClose}>Cancel</Button>
//           <Button type="submit" variant="contained">{isEdit ? "Update Task" : "Create Task"}</Button>
//         </DialogActions>
//       </Form>
//     )}
//   </Formik>
// </Dialog>

//   );
// };

// export default AddTaskFormModal;
